import { FC } from 'react'
import { Box, IconButton, Typography } from '@mui/material'
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace'
import { useNavigate } from 'react-router-dom'
import * as React from 'react'
import Favorites from '@/components/Organisms/Favorites/Favorites'

type TypeFormAddHeader = {
  title: string
  onFavoriteListChange?: (ids: number[]) => void
}

const FormAddHeader: FC<TypeFormAddHeader> = ({
  title,
  onFavoriteListChange,
}) => {
  const navigate = useNavigate()
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
        marginLeft: '-6px',
      }}
    >
      <IconButton onClick={() => navigate(-1)}>
        <KeyboardBackspaceIcon />
      </IconButton>
      <Typography variant='h6'>{title}</Typography>
      <Favorites onFavoriteListChange={onFavoriteListChange} />
    </Box>
  )
}

export default FormAddHeader
